import {
  GbegvtauftraganmeldungService,
  GbgrundbuchgeschaeftService,
  GbgrundstueckService,
  GrundbuchgeschaeftRestDetailEntryMeta
} from '../../../core/gb-api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { map, switchMap } from 'rxjs/operators';
import { AvgeometergeschaeftService, AvReferenzNummerListEntry, GbGeschaeftId, GeometergeschaeftListEntryMeta } from '../../../core/av-api';
import { AuftragListEntryMeta, AuftragService } from '../../../core/auftrag-api';
import { TimepointService } from '../../../core/services/timepoint.service';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { ErweiterungConfigResponse } from '../../../core/base-api';
import { AbstractComponent } from '../../../shared/components/abstract-component/abstract.component';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { ListLoaderPaginationBuilder } from '../../../shared/components/list-loader/list-loader-pagination';
import { PaginationLookupResult } from '../../../shared/components/list-loader/pagination-lookup-result';
import { AppPermissionService } from '../../../core/services/app-permission.service';
import { KompaktGrundstueckPipe } from '../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import { KompaktGrundstueckbeschreibungPipe } from '../../../shared/kompaktdarstellung/grundstueck-beschreibung/kompakt-grundstueckbeschreibung.pipe';
import {
  GrundstueckListEntryVm,
  GrundstueckSelection,
  GrundstueckTableComponent
} from '../../../shared/widgets/grundstueck-table/grundstueck-table.component';
import { DokulinkItemBuilderFactory } from '../../../shared/components/dokulink/dokulinkItemBuilderFactory';
import { combineLatest, Observable } from 'rxjs';
import { FormatAvReferenzNummerPipe } from '../../../shared/pipes/format/format-av-referenz-nummer.pipe';
import { GrundstuecknummerPipe } from '../../../shared/pipes/simple/grundstuecknummer.pipe';
import { GrundstueckAuszugSettingsComponent } from '../../../shared/components/auszug/settings/grundstueck-auszug-settings.component';
import { AuszugPrintService } from '../../../shared/components/auszug/auszug-print-service';
import {
  NgbDropdown,
  NgbDropdownMenu,
  NgbDropdownToggle,
  NgbModal,
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavItemRole,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavOutlet
} from '@ng-bootstrap/ng-bootstrap';
import { GbPrintService } from '../../../core/services/app-print.service';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { CapSpinnerSmallComponent } from '../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import { LinkComponent } from '../../../shared/components/link/link.component';
import { Ech0134GrundbuchmeldungDeleteButtonComponent } from '../../../ech0134/grundbuchmeldung/grundbuchmeldung-delete-button/ech0134-grundbuchmeldung-delete-button.component';
import { KopfdatenelementComponent } from '../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { DokulinkComponent } from '../../../shared/components/dokulink/dokulink.component';
import { StammpersonTableComponent } from '../../../shared/widgets/person/stammperson-table/stammperson-table.component';
import { Ech0134GrundbuchgeschaeftDetailComponent } from '../../../ech0134/grundbuchgeschaeft-detail/ech0134-grundbuchgeschaeft-detail.component';
import { BeschreibungTableWrapperComponent } from '../../../shared/components/table/beschreibung-table-wrapper.component';
import { GeogeschaeftTableComponent } from '../../../shared/widgets/geogeschaeft-table/geogeschaeft-table.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { AuftragsNummerPipe } from '../../../shared/pipes/simple/auftragsNummer.pipe';
import { DatumPipe } from '../../../shared/pipes/simple/datum.pipe';
import { DatumZeitPipe } from '../../../shared/pipes/simple/datumZeit.pipe';
import { FormatAvReferenzNummernPipe } from '../../../shared/pipes/format/format-av-referenz-nummern.pipe';
import { KompaktGrundbuchgeschaeftPipe } from '../../../shared/kompaktdarstellung/grundbuchgeschaeft/kompakt-grundbuchgeschaeft.pipe';
import { TranslateNamePipe } from '../../../shared/pipes/simple/translate-name.pipe';
import { CmisComponent } from '../../../shared/components/cmis/cmis.component';
import { FormatTimepointPipe } from '../../../shared/pipes/format/format-timepoint.pipe';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;
import MeldungsrelevantEnum = GrundbuchgeschaeftRestDetailEntryMeta.MeldungsrelevantEnum;
import StatusEnum = AuftragListEntryMeta.StatusEnum;

@Component({
  selector: 'cap-grundbuchgeschaeft-detail',
  templateUrl: './grundbuchgeschaeft-detail.component.html',
  styleUrls: ['./grundbuchgeschaeft-detail.component.scss'],
  imports: [
    NgTemplateOutlet,
    CapSpinnerSmallComponent,
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    LinkComponent,
    Ech0134GrundbuchmeldungDeleteButtonComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    KopfdatenelementComponent,
    DokulinkComponent,
    CmisComponent,
    StammpersonTableComponent,
    Ech0134GrundbuchgeschaeftDetailComponent,
    NgbNavOutlet,
    BeschreibungTableWrapperComponent,
    GeogeschaeftTableComponent,
    FunctionbarSearchresultButtonsComponent,
    GrundstueckTableComponent,
    AsyncPipe,
    TranslatePipe,
    AuftragsNummerPipe,
    DatumPipe,
    DatumZeitPipe,
    FormatAvReferenzNummernPipe,
    KompaktGrundbuchgeschaeftPipe,
    TranslateNamePipe,
    FormatTimepointPipe
  ]
})
export class GrundbuchgeschaeftDetailComponent extends AbstractComponent implements OnInit, OnDestroy {
  private readonly PAGE_SIZE = 15;
  private readonly CURRENT_PAGE = 1;
  private readonly DEFAULT_TAB_ID = 'geschaeftDetails';
  private readonly ECH_0134_TAB_ID = 'meldungsempfaenger';
  private readonly ID_PARAMETER_NAME = 'id';
  private readonly FACH_ID_PARAMETER_NAME = 'egbtbid';
  private readonly ACTIVE_TAB_ID_PARAMETER_NAME = 'activeTabId';
  private _geschaeft: GrundbuchgeschaeftRestDetailEntryMeta;

  eGVAnmeldung = '';
  auftrag: AuftragListEntryMeta;
  isAvplusOn = false;
  isECH0134On = false;
  isGrundbuchmeldungOn = false;
  hasRightGbMeldung = false;
  isAuftragsmodulOn = false;
  hasECH0134Right = false;
  activeTabId = this.DEFAULT_TAB_ID;
  geoGeschaeftLoader: ListLoader<GeometergeschaeftListEntryMeta>;
  grundstueckLoader: ListLoader<GrundstueckListEntryVm>;

  isShowAvReferenzNummern = false;
  avReferenzNrs$: Observable<AvReferenzNummerListEntry[]>;
  grundstueckIds = [];

  constructor(
    protected appformatConfigService: FormatConfigService,
    private route: ActivatedRoute,
    private gbGrundbuchgeschaeftService: GbgrundbuchgeschaeftService,
    private translate: TranslateService,
    private geometerGeschaeftService: AvgeometergeschaeftService,
    private grundstueckService: GbgrundstueckService,
    private egvtAuftragService: GbegvtauftraganmeldungService,
    private auftragService: AuftragService,
    private appPermissionService: AppPermissionService,
    private timepointService: TimepointService,
    private kompaktGrundstueckPipe: KompaktGrundstueckPipe,
    private kompaktGrundstueckBeschreibung: KompaktGrundstueckbeschreibungPipe,
    private formatAvReferenzNummerPipe: FormatAvReferenzNummerPipe,
    private grundstuecknummerPipe: GrundstuecknummerPipe,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory,
    protected router: Router,
    private auszugService: AuszugPrintService,
    private modalService: NgbModal,
    private gbPrintService: GbPrintService
  ) {
    super();
    keysToTranslate<string>([
      'AuftragsNummerAblage',
      'AnmelderText',
      'EGVAnmeldung',
      'AdressenN',
      'navigation.grundbuchmeldung',
      'Ausgang',
      'Bearbeiter'
    ]);
    keysToTranslate<StatusEnum>([
      'ABGESCHLOSSEN_OHNE_GRUNDBUCH',
      'ABGESCHLOSSEN_MIT_GRUNDBUCH',
      'BEREITZURUEBERNAHME',
      'BEREIT_FUER_TAGEBUCH',
      'EROEFFNET',
      'GRUNDBUCH',
      'GRUNDBUCH_ABGESCHLOSSEN',
      'STORNIERT'
    ]);
  }

  ngOnInit() {
    this.hasRightGbMeldung = this.appPermissionService.hasPermission('GRUNDBUCH_MELDUNGEN_REGISTER');
    this.addSub(
      this.appformatConfigService.settingsConfig$.subscribe((config) => {
        this.isShowAvReferenzNummern = config?.isUseAvReferenceNumbers;
      })
    );

    this.addSub(
      this.appformatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isAvplusOn = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.AV_PLUS);
        this.isECH0134On = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.ECH_0134);
        this.isGrundbuchmeldungOn =
          config?.activeErweiterungen.includes(ActiveErweiterungenEnum.HANDAENDERUNGSMELDUNG) &&
          config.activeErweiterungen.includes(ActiveErweiterungenEnum.MELDUNGEN_STANDARD);
        this.isAuftragsmodulOn = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.AUFTRAGS_MODUL);
      })
    );

    this.addSub(
      combineLatest(this.route.params, this.route.queryParams)
        .pipe(
          map((results) => ({ params: results[0], query: results[1] })),
          switchMap((params) => {
            const id = params.params[this.ID_PARAMETER_NAME];
            const egbtbid = params.query[this.FACH_ID_PARAMETER_NAME];
            if (id) {
              this.timepointService.timepointId = id;
              return this.gbGrundbuchgeschaeftService.loadGbGeschaeftById(id);
            } else if (egbtbid) {
              return this.gbGrundbuchgeschaeftService.loadGbGeschaeftByEgbtbid(egbtbid);
            }
            this.router.navigate(['/home/invalidrequest']);
          })
        )
        .subscribe({
          next: (entry) => {
            if (!this.timepointService.timepointCtx.timepointId) {
              this.timepointService.timepointId = entry.id.id;
            }
            this.geschaeft = entry;
            this.geoGeschaeftLoader = this.createGeoGeschaeftLoader(this.geschaeft.id);
            this.grundstueckLoader = this.crateGrundstueckLoader(this.geschaeft.id);
            this.egvtAuftragService.loadEgvtAuftragListEntryById(entry.id.id).subscribe({
              next: (a) => {
                this.eGVAnmeldung = a ? a.anmeldungsId : '';
              },
              error: (err) => {
                if (err.status === 404) {
                  return;
                }
              }
            });
            this.avReferenzNrs$ = this.geometerGeschaeftService.loadAvReferenzNummerBy(this.geschaeft.id.id).pipe(map((a) => a.results));
            this.loadAuftrag(entry);
            this.hasECH0134Right =
              MeldungsrelevantEnum.JA === this._geschaeft.meldungsrelevant &&
              (this.appPermissionService.hasPermission('ECH_0134_SUCHEN') ||
                this.appPermissionService.hasPermission('ECH_0134_VERWALTEN_MELDUNG'));
          },
          error: (err) => {
            if (err.status === 404) {
              this.router.navigate(['/home/notfound']);
            }
            if (err.status === 403) {
              this.router.navigate(['/security/forbidden']);
            }
          }
        })
    );
  }

  set geschaeft(value) {
    this._geschaeft = value;
    const sub = this.route.queryParamMap.subscribe((q) => {
      if (q.get(this.ACTIVE_TAB_ID_PARAMETER_NAME)) {
        this.activeTabId = q.get(this.ACTIVE_TAB_ID_PARAMETER_NAME);
        if (this.ECH_0134_TAB_ID === this.activeTabId && (!this.isECH0134On || !this.hasECH0134Right)) {
          this.activeTabId = this.DEFAULT_TAB_ID;
        }
      }
    });
    this.subscriptions.push(sub);
  }

  get geschaeft() {
    return this._geschaeft;
  }

  private loadAuftrag(entry) {
    if (this.isAuftragsmodulOn) {
      this.auftragService.searchAuftragByGeschaeftsId(entry.id.id).subscribe((r) => {
        if (r && r.results.length > 0) {
          this.auftrag = r.results[0];
        }
      });
    }
  }

  private createGeoGeschaeftLoader(geschaeft: GbGeschaeftId): ListLoader<GeometergeschaeftListEntryMeta> {
    const observable = (offset, limit) =>
      this.geometerGeschaeftService.loadGeometergeschaeftSichtGbGeschaeft(geschaeft.id, offset, limit).pipe(
        map(
          (r) =>
            <PaginationLookupResult<GeometergeschaeftListEntryMeta>>{
              result: r.results,
              totalItems: r.totalItems
            }
        )
      );
    const loader = ListLoaderPaginationBuilder.builder<GeometergeschaeftListEntryMeta>()
      .setLookupItemFunc(observable)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPageSize(this.PAGE_SIZE)
      .build();
    this.addLoader(loader);
    return loader;
  }

  private crateGrundstueckLoader(geschaeftId: GbGeschaeftId): ListLoader<GrundstueckListEntryVm> {
    const observable = (offset, limit, sortColumn) =>
      this.grundstueckService
        .loadGrundstueckSichtByGeschaeftId(
          'GB',
          geschaeftId.id,
          'OHNE_HIST',
          offset,
          limit,
          sortColumn.sortDirectionBackend,
          sortColumn.sortEnumBackend
        )
        .pipe(
          map((r) => {
            const grundstueckListEntryVms = r.results.map(
              (e) =>
                new GrundstueckListEntryVm(e, {
                  translate: this.translate,
                  kompaktGrundstueckBeschreibung: this.kompaktGrundstueckBeschreibung,
                  grundstuecknummerPipe: this.grundstuecknummerPipe,
                  kompaktGrundstueckPipe: this.kompaktGrundstueckPipe,
                  dokuLinkBuilderFactory: this.dokuLinkBuilderFactory
                })
            );
            return <PaginationLookupResult<GrundstueckListEntryVm>>{
              result: grundstueckListEntryVms,
              totalItems: r.totalItems
            };
          })
        );

    const loader = ListLoaderPaginationBuilder.builder<GrundstueckListEntryVm>()
      .setLookupItemFunc(observable)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPageSize(this.PAGE_SIZE)
      .build();
    this.addLoader(loader);
    return loader;
  }

  getZip() {
    this.selectGrundstueckSettings(this.grundstueckIds);
  }

  selectGrundstueckSettings(list) {
    const modalRef = this.modalService.open(GrundstueckAuszugSettingsComponent);
    modalRef.componentInstance.hasToZip = true;
    modalRef.componentInstance.ids = list;
    modalRef.componentInstance.indexNumber = 0;
  }

  updateCheckedGrundstueckIdList($event: GrundstueckSelection) {
    this.grundstueckIds = $event.grundstueckIds;
  }
}
